import { Component, inject } from '@angular/core';
import { DialogComponent } from '../../../ui-kit/common/components/dialog/dialog.component';
import { DialogService } from '../../core/services/dialog.service';
import { DialogAction } from '../../core/interfaces/dialog';
import { AuthStore } from '../../store/auth.store';
import { NavigationService } from '../../core/services/navigation.service';
import { DialogKeys } from '../../core/enums/dialog-keys.enum';
import { PauseDialogCoordinator } from '../pause-dialog/pause-dialog.coordinator';

@Component({
  selector: 'app-logout-dialog',
  imports: [DialogComponent],
  templateUrl: './logout-dialog.component.html',
  styleUrl: './logout-dialog.component.scss',
})
export class LogoutDialogComponent {
  private readonly authStore = inject(AuthStore);
  private readonly pauseDialogCoordinator = inject(PauseDialogCoordinator);
  public openButtonLabel?: string;
  public openButtonIcon?: string;
  public dialogService = inject(DialogService);
  public navigationService = inject(NavigationService);

  public DialogKeys = DialogKeys;

  public modalActions: DialogAction[] = [
    {
      label: 'LogoutDialog.Cancel',
      action: () => this.closeDialog(),
      type: 'secondary',
      icon: '',
    },
    {
      label: 'LogoutDialog.Logoff',
      action: () => this.logout(),
      type: 'primary',
      icon: '',
    },
  ];

  public open() {
    this.dialogService.open(DialogKeys.Logout, {
      title: 'LogoutDialog.Title',
      description: 'LogoutDialog.Content',
      actions: this.modalActions,
    });
  }

  public async logout() {
    await this.pauseDialogCoordinator.runStopHandler(DialogKeys.Logout);
    this.navigationService.enableBypass();
    this.authStore.centralLogout();
  }

  public closeDialog() {
    this.dialogService.close();
  }
}
